import { render, staticRenderFns } from "./NotificationPreviewDialog.vue?vue&type=template&id=c46f5290&scoped=true"
import script from "./NotificationPreviewDialog.vue?vue&type=script&lang=js"
export * from "./NotificationPreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./NotificationPreviewDialog.vue?vue&type=style&index=0&id=c46f5290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46f5290",
  null
  
)

export default component.exports